const track = (trackingObj) => {
  if (window.dataLayer) {
    window.dataLayer.push({ ...trackingObj })
  }
}
const recipeClick = ({ recipeName, currentFilters, placement }) => {
  track({
    event: 'facetRecipeCardClick',
    recipeName,
    currentFilters,
    placement
  })
}

const removeAllFilters = ({ store, placement }) => {
  const { currentTagsAndTerms: currentFilters } = store.getters
  track({
    event: 'removeAllFilters',
    currentFilters,
    placement
  })
}

const removeFilter = ({ currentFilters = '', placement, filterName }) => {
  track({
    event: 'removeFilter',
    currentFilters,
    filterName,
    placement
  })
}

const selectFilter = ({
  currentFilters = '',
  placement,
  filterName,
  filterCategory = ''
}) => {
  track({
    event: 'selectFilter',
    currentFilters,
    filterName,
    filterCategory,
    placement
  })
}

const openFilterMenu = ({ currentFilters = '', placement }) => {
  track({
    event: 'openFilterMenu',
    currentFilters,
    placement
  })
}

const closeFilterMenu = ({ placement }) => {
  track({
    event: 'filterMenuClose',
    placement
  })
}

const expandFilterMenu = ({ currentFilters = '', filterCategory, placement }) => {
  track({
    event: 'expandFilterSubMenu',
    filterCategory,
    currentFilters,
    placement
  })
}

const submitFilterSearch = ({ currentFilters = '', filterName, placement }) => {
  track({
    event: 'submitFilterSearch',
    filterName,
    currentFilters,
    placement
  })
}

const submitRecipeSearch = ({ searchTerm, placement }) => {
  track({
    event: 'dropdownTagSearch',
    searchTerm,
    placement
  })
}

const facetSliderClick = ({ sliderItemTitle, sliderTitle, placement }) => {
  track({
    event: 'sliderItemClick',
    sliderTitle,
    sliderItemTitle,
    placement
  })
}

const relatedFacetSlider = ({ facetName, relatedFacetName, placement }) => {
  track({
    event: 'sliderRelatedFacet',
    facetName,
    relatedFacetName,
    placement
  })
}

const facetSlider = ({ facetName, placement }) => {
  track({
    event: 'sliderFacet',
    facetName,
    placement
  })
}

const sliderScroll = ({
  interactionType, sliderTitle, direction, placement
}) => {
  track({
    event: 'sliderScroll',
    interactionType,
    sliderTitle,
    direction,
    placement
  })
}

const loadMore = (placement) => {
  track({
    event: 'loadMore',
    placement
  })
}

const productDiscoverMore = ({ linkName, placement }) => {
  track({
    event: 'productDiscoverMore',
    linkName,
    placement
  })
}

const mainMenuItemClick = (event, topMenuTitleText) => {
  track({
    event,
    topMenuTitleText
  })
}

const mainMenuSectionTitleClick = (linkName, categoryName) => {
  track({
    event: 'menuDropdownSectionTitleClick',
    linkName,
    categoryName
  })
}

const mainMenuDropdownLinkClick = (linkName, categoryName) => {
  track({
    event: 'menuDropdownNavigationClick',
    linkName,
    categoryName
  })
}

const mainMenuNavigationOpen = () => {
  track({
    event: 'menuNavigationOpen'
  })
}

const mainMenuNavigationClose = () => {
  track({
    event: 'menuNavigationClose'
  })
}

const mainMenuPreviousClick = () => {
  track({
    event: 'menuNavigationPrevious'
  })
}

const ribbonMenuItemClick = (navigationItem) => {
  track({
    event: 'subMenuNavigationClick',
    navigationItem
  })
}

export default {
  track,
  recipeClick,
  removeAllFilters,
  removeFilter,
  selectFilter,
  openFilterMenu,
  closeFilterMenu,
  expandFilterMenu,
  submitFilterSearch,
  relatedFacetSlider,
  facetSlider,
  facetSliderClick,
  sliderScroll,
  submitRecipeSearch,
  loadMore,
  mainMenuItemClick,
  mainMenuSectionTitleClick,
  mainMenuDropdownLinkClick,
  mainMenuNavigationOpen,
  mainMenuNavigationClose,
  mainMenuPreviousClick,
  productDiscoverMore,
  ribbonMenuItemClick
}
